import { Link } from "react-router-dom";
import ArticleCard from "@/components/feature/ArticleCard";
import { getHotArticles } from "@/utils/content";

export default function HotRecommend() {
  const list = getHotArticles().slice(0, 4);

  return (
    <section className="mx-auto w-full max-w-[1280px] px-4 py-4 md:px-6">
      <div className="mb-6 flex items-end justify-between">
        <div className="flex items-center gap-2">
          <span className="h-5 w-1 rounded-full bg-accent-500" />
          <h2 className="text-xl font-bold text-foreground-950 md:text-2xl">热门内容推荐</h2>
        </div>
        <Link
          to="/search"
          className="whitespace-nowrap text-sm font-medium text-primary-600 transition-colors hover:text-primary-700"
        >
          发现更多 <i className="ri-arrow-right-s-line" />
        </Link>
      </div>
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {list.map((a) => (
          <ArticleCard key={a.id} article={a} variant="grid" />
        ))}
      </div>
    </section>
  );
}